import { createReducer, on } from '@ngrx/store';
import {
  loadInstrumentList,
  loadInstrumentListSuccess,
  loadInstrumentListFailure,
  clearInstrumentList,
} from './instrument.actions';

export interface InstrumentState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: InstrumentState = {
  data: null,
  loading: false,
  error: null,
};

export const instrumentReducer = createReducer(
  initialState,
  on(loadInstrumentList, (state) => ({ ...state, loading: true, error: null })),
  on(loadInstrumentListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadInstrumentListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearInstrumentList, (state) => ({ ...state, data: null }))
);
